import { CreateNamespaceModel } from "./CreateNamespaceModel";

/**
 * * Модель результата создания рабочей области
 */
export class CreateNamespaceResultModel extends CreateNamespaceModel {
  /**ID рабочей области */
  Id!: string;
  /**Кол-во задач */
  TaskCount!: number;

  constructor(obj?: Partial<CreateNamespaceResultModel>) {
    super(obj);
    Object.assign(this, obj);
  }
}
